module.exports = __webpack_public_path__ + "img/sponsor-carousel-alabama-power.057eb322.jpg";